import { AppDefaults } from 'config/global-enums';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export default function MainHelmet() {
  const { i18n } = useTranslation();
  return (
    <Helmet
      titleTemplate={`%s - ${AppDefaults.APP_NAME}`}
      defaultTitle={AppDefaults.APP_NAME}
      htmlAttributes={{ lang: i18n.language }}
    >
      <meta name="description" content={AppDefaults.APP_DESCRIPTION} />
    </Helmet>
  );
}
